import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const ProductsWrapper = styled(Stack)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  // Fallback for non-Webkit browsers
  display: flex;
  flex-wrap: wrap;
`;
